import {
  AccordionListHeader,
  Item,
  Title,
  FakeLabel,
  Header,
  ListHeaderLayout,
  ListContent,
  ListItem,
  ListCheckboxItem,
  Divider,
  Trigger,
  Chevron,
  Accordion as DSAccordion
} from "@packages/ds";

import { TrackedAccordionRoot } from "./TrackedRoot";
import { TrackedAccordionSectionHeader } from "./TrackedSectionHeader";

export type { TrackedAccordionRootProps } from "./TrackedRoot";
export type { TrackedAccordionSectionHeaderProps } from "./TrackedSectionHeader";

// Re-export the components from design system
export {
  Item,
  Title,
  FakeLabel,
  Header,
  ListHeaderLayout,
  ListContent,
  ListItem,
  ListCheckboxItem,
  Divider,
  Trigger,
  Chevron
};

// Use the Content from the DS Accordion namespace
export const Content = DSAccordion.Content;

// Export tracked components
export const Root = TrackedAccordionRoot;
export const SectionHeader = TrackedAccordionSectionHeader;
export const ListHeader = AccordionListHeader;

// Export a namespace for consistency with the DS package
export const Accordion = {
  Root: TrackedAccordionRoot,
  Item,
  Content,
  SectionHeader: TrackedAccordionSectionHeader,
  ListHeader: AccordionListHeader,
  ListContent,
  ListItem,
  ListCheckboxItem
};
